import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityCompiler from '../../components/Modals/ModalEntityCompiler';
import { DataManager } from '../../core/data-manager';
import { toast } from 'react-toastify';
import VoyageDocuments from './VoyageDocuments';


export default function DGSH_voyage_double({ data, setData, entity = null, selectedRows, setSelectedRows, refreshData }) {

    useEffect(() => {

    }, []);


    async function deleteVoyage() {
        var count = 0;
        for (let i = 0; i < selectedRows.length; i++) {
            var res = await DataManager.deleteItem('voyage', selectedRows[i]);
            if (res.success === 1) {
                count++;
            } else {
                toast.error("Errore nella eliminazione del viaggio!", { theme: 'colored' })
            }
        }
        if (count === selectedRows.length) {
            toast.success("Viaggi eliminati con successo!", { theme: 'colored' })
            refreshData()
        }

    }

    async function ignoreVoyage() {
        var count = 0;
        for (let i = 0; i < selectedRows.length; i++) {
            var body = {
                ignoreDouble: 1
            }
            var res = await DataManager.updateItem('voyage', body, selectedRows[i]);
            if (res.success === 1) {
                count++;
            } else {
                toast.error("Errore nell'ignorare il viaggio duplicato!", { theme: 'colored' })
            }
        }
        if (count === selectedRows.length) {
            toast.success("Viaggi ignorati con successo!", { theme: 'colored' })
            refreshData()
        }
    }



    return (
        <>
            <div className='d-flex flex-row my-2'>
                <Button variant='outline-primary' size='sm' className='me-1' onClick={() => ignoreVoyage()}>Ignora selezionati</Button>
                <Button variant='outline-danger' size='sm' onClick={() => deleteVoyage()}>Elimina selezionati</Button>
            </div>


        </>
    )
};